module.exports = __webpack_public_path__ + "static/media/logo-new.cf86200b.png";